import { useMemo } from 'react';
import { Modal, Typography } from 'antd';

import CondensedTable from 'components/CondensedTable/CondensedTable';
import { formatDate } from 'utilities/datesAndTimes';

const columns = Object.freeze([
  {
    title: 'Date',
    dataIndex: 'date',
    render: (date) => {
      return formatDate(date);
    },
  },
  {
    title: 'Event',
    dataIndex: 'courier',
    render: (courier) => {
      return courier ? 'shipped' : 'created';
    },
  },
  { title: 'Courier', dataIndex: 'courier' },
  { title: 'Tracking Number', dataIndex: 'trackingNumber' },
]);

const CardShippingEventsModal = ({ events = [], open, ...modalProps }) => {
  const sortedEvents = useMemo(() => {
    return [...events].sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [events]);
  return (
    <Modal
      {...modalProps}
      centered
      width={640}
      cancelButtonProps={{ hidden: true }}
      title="Card Fulfillment History"
      open={open}
    >
      <Typography.Paragraph>
        "Shipped" events reflect the true mailing date. For "Created" events,
        please add up to 2 days for the card to be mailed.
      </Typography.Paragraph>
      <CondensedTable
        data={sortedEvents}
        columns={columns}
        bordered={true}
        length={10}
        size="small"
      ></CondensedTable>
    </Modal>
  );
};

export default CardShippingEventsModal;
